import { DateField } from './DateField'
import { withDateField } from './withDateField'

const ConnectedDateField = withDateField(DateField)

export { ConnectedDateField as DateField }
